import { render, staticRenderFns } from "./RequestCreatorProduct.vue?vue&type=template&id=7c8963a8&scoped=true&"
import script from "./RequestCreatorProduct.vue?vue&type=script&lang=js&"
export * from "./RequestCreatorProduct.vue?vue&type=script&lang=js&"
import style0 from "./RequestCreatorProduct.vue?vue&type=style&index=0&id=7c8963a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c8963a8",
  null
  
)

export default component.exports